import React from 'react';
import firebase from 'firebase';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Upload, message } from 'antd';
import uuid from 'uuid/v4';
import urljoin from 'url-join';
import ReactCrop from 'react-image-crop';
import ImgCrop from 'antd-img-crop';
import { compress, compressAccurately } from 'image-conversion';

function beforeUpload(file: File) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Solo puedes utilizar imágenes en formato JPG o PNG!');
  }
  // const isLt2M = file.size / 1024 / 1024 < 2;
  // if (!isLt2M) {
  //   message.error('La imagen debe ser más pequeña que 2MB!');
  // }
  return isJpgOrPng;
}

export interface IFirebaseImage {
  reference: string;
  downloadURL: string;
}

interface IProps {
  storageRef: string;
  onUploadComplete: (image: IFirebaseImage) => any;
  overrideImageURL?: string;
}

export default class AvatarUploader extends React.Component<IProps> {
  state = {
    loading: false,
    image: {
      reference: '',
      downloadURL: '',
    },
  };

  async componentDidMount() {
    if (this.props.overrideImageURL) {
      const ref = await firebase
        .storage()
        .refFromURL(this.props.overrideImageURL);
      const downloadURL = await firebase
        .storage()
        .refFromURL(this.props.overrideImageURL)
        .getDownloadURL();

      this.setState({
        image: {
          reference: ref,
          downloadURL,
        },
      });
    }
  }

  customUpload = async (args: any) => {
    const storageUrl = urljoin(this.props.storageRef, `/${uuid()}`);
    const storageRef = firebase.storage().ref(storageUrl);
    const task = storageRef.put(args.file);

    task.on(
      'state_changed',
      () => {
        this.setState({
          loading: true,
        });
      },
      (error: any) => {
        this.setState({
          loading: false,
        });
      },
      async () => {
        // Upload complete
        const reference = task.snapshot.ref.toString();
        const downloadURL = await task.snapshot.ref.getDownloadURL();
        this.props.onUploadComplete({ reference, downloadURL });
        this.setState({
          loading: false,
          image: {
            reference,
            downloadURL,
          },
        });
      },
    );
  };

  transformFile = async (file: File) => {
    const compressed = await compressAccurately(file, 500);
    return compressed;
  };

  render() {
    const uploadButton = (
      <div>
        <LegacyIcon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Cargar</div>
      </div>
    );
    const image = this.state.image;
    return (
      <ImgCrop grid>
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          beforeUpload={beforeUpload}
          customRequest={this.customUpload}
          transformFile={this.transformFile}
        >
          {image.downloadURL ? (
            <img
              src={image.downloadURL}
              alt="avatar"
              style={{ width: '100%' }}
            />
          ) : (
            uploadButton
          )}
        </Upload>
      </ImgCrop>
    );
  }
}
